module.exports = {"331082001":"古城街道","331082002":"大洋街道","331082003":"江南街道","331082004":"大田街道","331082005":"邵家渡街道","331082100":"汛桥镇","331082101":"东塍镇","331082103":"汇溪镇","331082104":"小芝镇","331082105":"河头镇","331082106":"白水洋镇","331082107":"括苍镇","331082108":"永丰镇","331082109":"尤溪镇","331082110":"涌泉镇","331082111":"沿江镇","331082112":"杜桥镇","331082113":"上盘镇","331082114":"桃渚镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331082.json
// module id = 1024
// module chunks = 0